import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import PostalCodeSearch from "../components/common/PostalCodeSearch";
import { postRequest } from "../services/apiMethods";
import { useMutation } from "@tanstack/react-query";
// import toast from "react-hot-toast";
import { capitalizeFirstLetter } from "../ulit/HelperFunctions";

export default function Register() {
  const [searchParams] = useSearchParams();
  const [localLoading, setLocalLoading] = useState(false);
  const id = searchParams.get("id");
  const navigate = useNavigate(); // fixed naming

  const formik = useFormik({
    initialValues: {
      firstName: "",
      surname: "",
      email: "",
      postcode: "",
      userLocationLng: "",
      userLocationLat: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First name is required"),
      surname: Yup.string().required("Surname is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      postcode: Yup.string().required("Post code is required"),
    }),
    validateOnBlur: false,
    onSubmit: async (values) => {
      await handleSubmit(values);
    },
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: (data) => postRequest(`/user/create`, data),
    onMutate: () => setLocalLoading(true),
    onSuccess: (data) => {
      // debugger
      // toast.success(`${data?.message}`, {
      //   iconTheme: {
      //     primary: "#337FE0",
      //     secondary: "#FFFAEE",
      //   },
      // });
      navigate(`/club-location?id=${data?.user?._id}`);
      //  navigate(`/set-password`);
      sessionStorage.setItem("userId", data?.user?._id);
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
    onSettled: () => setLocalLoading(false),
  });

  const handleSubmit = async (values) => {
    // Mark all fields as touched
    formik.setTouched({
      firstName: true,
      surname: true,
      email: true,
      postcode: true,
    });

    const errors = await formik.validateForm();
    if (Object.keys(errors).length === 0) {
      const payload = {
        subscriptionId: id,
        role: "user",
        firstName: values.firstName,
        lastName: values.surname,
        email: values.email,
        address: {
          postcode: values.postcode,
        },
        userLocation: {
          type: "Point",
          coordinates: [values.userLocationLng, values.userLocationLat],
        },
      };
      mutate(payload);
    }
  };

  const handleLocationSelect = (newLocation) => {
    formik.setFieldValue("userLocationLng", newLocation.lng);
    formik.setFieldValue("userLocationLat", newLocation.lat);
    formik.setFieldValue("postcode", newLocation?.postalCode);
    sessionStorage.setItem("postcode", newLocation?.postalCode);
  };

  return (
    <section className="commn-bg-set">
      <div className="card-center-set">
        <div className="commn-card-theme">
          <img
            className="side-logo-set"
            src={require("../Assets/images/logo-main.png")}
            alt="Logo"
          />
          <h2>Register</h2>
          <p>Become a Quaffee Club member today</p>

          <div className="register-data">
            <Form onSubmit={formik.handleSubmit}>
              <Form.Group className="mb-3" controlId="firstName">
                <Form.Label>First name</Form.Label>
                <Form.Control
                  type="text"
                  name="firstName"
                  placeholder="eg: Sarah"
                  value={formik.values.firstName}
                  // onChange={formik.handleChange}
                  onChange={(e) =>
                    formik.setFieldValue(
                      "firstName",
                      capitalizeFirstLetter(e.target.value)
                    )
                  }
                />
                {formik.errors.firstName && formik.touched.firstName && (
                  <div className="text-danger small mt-1">
                    {formik.errors.firstName}
                  </div>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="surname">
                <Form.Label>Surname</Form.Label>
                <Form.Control
                  type="text"
                  name="surname"
                  placeholder="eg: Jones"
                  value={formik.values.surname}
                  // onChange={formik.handleChange}
                  onChange={(e) =>
                    formik.setFieldValue(
                      "surname",
                      capitalizeFirstLetter(e.target.value)
                    )
                  }
                />
                {formik.errors.surname && formik.touched.surname && (
                  <div className="text-danger small mt-1">
                    {formik.errors.surname}
                  </div>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="eg: sarah@example.com"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  autoComplete="new-password"
                  // readOnly
                  // onFocus={(e) => e.target.removeAttribute("readOnly")}
                />
                {formik.errors.email && formik.touched.email && (
                  <div className="text-danger small mt-1">
                    {formik.errors.email}
                  </div>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="postcode">
                <Form.Label>Your Post Code</Form.Label>
                <PostalCodeSearch
                  onLocationSelect={handleLocationSelect}
                  mapLoaded={true}
                />
                {formik.errors.postcode && formik.touched.postcode && (
                  <div className="text-danger small mt-1">
                    {formik.errors.postcode}
                  </div>
                )}
                <Form.Text className="text-white d-block mt-2">
                  We’ll find your nearest participating store for you to claim
                  your beverages.
                </Form.Text>
              </Form.Group>

              <Button
                variant="primary"
                type="submit"
                disabled={localLoading || isLoading}
              >
                {localLoading || isLoading ? "Processing..." : "Next"}
              </Button>
            </Form>
          </div>
          <div className="text-center mt-4">
            <Link to="/terms-and-conditions">
              <p className="mb-0">Terms and Conditions</p>
            </Link>{" "}
          </div>
        </div>
      </div>
    </section>
  );
}
